import type {Component, Document} from 'src/typings';
import './kp-documents-slider.less'
import KpCover from '../../../features/record/kp-cover/KpCover.svelte';
import {uuid as generateUuid} from 'shared/utils/custom-utils';
import Labels from 'shared/components/kp-label/Labels.svelte';

interface KpDocumentsSliderComponentBindings {
    documents: Document[];
}

/**
 * @ngdoc component
 * @name kpDocumentSlider
 * @module portaro.components
 *
 * @param {Document[]} documents documents stored in moving slider
 *
 * @description
 * Component for storing similar types of documents
 */
export default class KpDocumentsSliderComponent implements Component<KpDocumentsSliderComponentBindings> {
    public static componentName = 'kpDocumentsSlider';

    public templateUrl = require('./kp-documents-slider.tpl.ftl');
    public bindings = {
        documents: '<'
    } as const;
    public controller = KpDocumentsSliderComponentController;
}

class KpDocumentsSliderComponentController implements KpDocumentsSliderComponentBindings {
    public documents: Document[];
    public kpCoverComponent = KpCover;
    public labelsComponent = Labels;

    public uniq = generateUuid();
    public settings = {
        prevArrow: `#btn-slider-prev-${this.uniq}`,
        nextArrow: `#btn-slider-next-${this.uniq}`
    }
}